import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { loadSiteConfig } from '@/lib/features'

// Import base styles
import './index.css'

// Get tenant from env
const tenant = import.meta.env.VITE_TENANT || 'default'

// Dynamic theme loading
async function loadTheme() {
  try {
    if (tenant === 'astaka') {
      await import('./styles/themes/astaka.css')
      document.documentElement.classList.add('astaka-theme')
    } else if (tenant === 'nadi') {
      await import('./styles/themes/nadi.css')
      document.documentElement.classList.add('nadi-theme')
    }
  } catch (e) {
    console.warn('Could not load theme:', e)
  }
}

// Create the router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Load theme and site config before rendering
Promise.all([loadTheme(), loadSiteConfig()]).then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  )
})
